module.exports = __webpack_public_path__ + "img/andrew-flash-sale.68b84692.png";